import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { styled } from '@mui/system';

import { MUTED, SANS_STACK, TEXT_DARK } from './tokens';

export const DISABLED_BG = '#e0e0e0';

/**
 * The green-ringed chip the tag grid turns into while a name is being typed —
 * shared by the composer (a new tag) and by TagChip's rename mode.
 */
export const TagEditShell = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.success.main}`,
  borderRadius: 10,
  background: '#fff',
  boxShadow: `${alpha(theme.palette.success.main, 0.15)} 0 0 0 3px`,
  overflow: 'hidden',
  height: 32,
}));

// Full-height button flush against the shell's inner edge.
export const TagEditButton = styled('button')({
  border: 'none',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
});

// The leading tag glyph, in the same green as the shell.
export function TagEditIcon() {
  return (
    <Box
      component="span"
      sx={{
        paddingLeft: '8px',
        color: 'success.main',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
      </svg>
    </Box>
  );
}

/**
 * Input styling for the shell. The width tracks the typed name; the
 * composer starts wider than rename because it opens empty.
 */
export function tagEditInputSx(length, minWidth) {
  return {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: '0.85rem',
    fontFamily: SANS_STACK,
    fontWeight: 400,
    color: TEXT_DARK,
    letterSpacing: '0.5px',
    padding: '0 6px',
    width: Math.max(minWidth, length * 8.5 + 16),
    minWidth,
    maxWidth: 220,
  };
}

// The line under the shell: what Enter and Esc will do, or why the name is
// refused.
export const tagEditHintSx = {
  fontSize: 11,
  marginTop: '4px',
  paddingLeft: '2px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: MUTED,
};
